import { BoxShadowWithRadius } from 'accessibility/focusStyles'
import cx from 'classnames'
import useKeyboardNavigation from 'hooks/useKeyboardNavigation'
import useThemeColors from 'hooks/useThemeColors'
import React, { useRef, useState } from 'react'

interface ImageAttachmentMessageProps {
  attachment: { publicUrl?: string, fileName?: string },
  resolveMessageHeight: () => void
}


const ImageAttachmentMessage = ({ attachment = {}, resolveMessageHeight = () => { } }: ImageAttachmentMessageProps) => {
  const [hasImageLoaded, setHasImageLoaded] = useState(false)
  const { activeColor } = useThemeColors()
  const fileAttachmentRef = useRef<HTMLAnchorElement>(null)
  const isFileAttachmentFocused = useKeyboardNavigation(fileAttachmentRef)

  return (
    <a
      href={attachment.publicUrl}
      className={cx("drift-widget-attachment--img", {
        'keyboard-focused': isFileAttachmentFocused
      })}
      target="_blank"
      ref={fileAttachmentRef}
      rel="nofollow noopener noreferrer"
      aria-label={`Click to download image: ${attachment.fileName}`}
    >
      <style>
        {`
          .drift-widget-attachment--img.keyboard-focused {
            ${BoxShadowWithRadius(activeColor, false)}
          }
        `}
      </style>
      <img
        src={attachment.publicUrl}
        alt={attachment.fileName}
        onLoad={() => {
          !hasImageLoaded && resolveMessageHeight()
          !hasImageLoaded && setHasImageLoaded(true)
        }}
      />
    </a>
  )
}

export default ImageAttachmentMessage
